var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _text, _text2, _text3, _text4, _text5, _text6, _path9, _path10, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 474,
    viewBox: "0 0 473 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0215759 90.9311L472.094 90.005L472.798 449.009C472.823 461.712 462.546 472.029 449.843 472.054L23.7709 472.89C11.0684 472.915 0.750781 462.638 0.725862 449.935L0.0215759 90.9311Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0451207 23.9261C0.0202012 11.2235 10.2974 0.9059 23 0.880981L449.072 0.0451229C461.775 0.0202034 472.092 10.2974 472.117 23L472.249 90.0286L0.176616 90.9547L0.0451207 23.9261Z",
    fill: "#220bab",
    className: "to-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 315.25C84.2132 315.25 89.25 310.213 89.25 304C89.25 297.787 84.2132 292.75 78 292.75C71.7868 292.75 66.75 297.787 66.75 304C66.75 310.213 71.7868 315.25 78 315.25Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.88 315.05C74.31 312.85 73.25 308.72 73.25 304.05C73.25 299.38 74.31 295.15 75.88 293",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.12 315.05C81.69 312.85 82.75 308.72 82.75 304.05C82.75 299.38 81.69 295.15 80.12 293",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.75 304H89.25",
    className: "to-fill",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.05 309.25H87.95",
    className: "to-fill",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.05 298.75H87.95",
    className: "to-fill",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.577 188.162C77.8215 188.406 78.1526 188.543 78.4979 188.543C78.8431 188.543 79.1742 188.406 79.4187 188.162L89.5082 178.073C89.5767 178.005 89.6249 177.919 89.6473 177.825C89.6697 177.731 89.6654 177.632 89.635 177.54C89.6047 177.448 89.5493 177.367 89.4752 177.305C89.4011 177.243 89.3112 177.202 89.2155 177.189C89.1165 177.174 89.0166 177.167 88.9165 177.167H68.0833C67.9826 177.167 67.882 177.174 67.7823 177.189C67.6866 177.202 67.5967 177.243 67.5226 177.305C67.4485 177.367 67.3931 177.448 67.3627 177.54C67.3324 177.632 67.3281 177.731 67.3505 177.825C67.3729 177.919 67.4211 178.005 67.4896 178.073L77.577 188.162Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8832 179.075C90.8484 179.06 90.8099 179.056 90.7728 179.063C90.7357 179.071 90.7016 179.089 90.6749 179.116L84.2166 185.574C84.1678 185.623 84.1405 185.689 84.1405 185.758C84.1405 185.827 84.1678 185.894 84.2166 185.943L89.4697 191.196C89.5443 191.268 89.6039 191.354 89.6449 191.449C89.6858 191.545 89.7074 191.647 89.7084 191.751C89.7093 191.854 89.6896 191.957 89.6504 192.053C89.6111 192.149 89.5532 192.237 89.4799 192.31C89.4065 192.383 89.3193 192.442 89.2233 192.481C89.1274 192.52 89.0245 192.54 88.9208 192.539C88.817 192.538 88.7145 192.517 88.6192 192.476C88.5238 192.435 88.4376 192.376 88.3655 192.301L83.1124 187.048C83.0882 187.024 83.0595 187.004 83.0278 186.991C82.9962 186.978 82.9623 186.971 82.928 186.971C82.8938 186.971 82.8599 186.978 82.8282 186.991C82.7966 187.004 82.7678 187.024 82.7437 187.048L80.526 189.266C79.9888 189.802 79.2604 190.104 78.501 190.104C77.7415 190.104 77.0131 189.802 76.476 189.266L74.2562 187.05C74.2072 187.001 74.1409 186.974 74.0718 186.974C74.0027 186.974 73.9364 187.001 73.8875 187.05L68.6344 192.303C68.4869 192.445 68.2896 192.524 68.0847 192.522C67.8799 192.52 67.684 192.438 67.5392 192.293C67.3944 192.148 67.3123 191.952 67.3107 191.747C67.309 191.542 67.3878 191.345 67.5302 191.198L72.7833 185.945C72.832 185.896 72.8594 185.829 72.8594 185.76C72.8594 185.691 72.832 185.625 72.7833 185.576L66.325 179.118C66.2984 179.091 66.2643 179.072 66.2271 179.065C66.1899 179.058 66.1514 179.062 66.1167 179.077C66.0824 179.091 66.0531 179.115 66.0324 179.146C66.0117 179.177 66.0004 179.213 66 179.25V191.75C66 192.302 66.2195 192.832 66.6102 193.223C67.0009 193.614 67.5308 193.833 68.0833 193.833H88.9165C89.4691 193.833 89.999 193.614 90.3897 193.223C90.7804 192.832 90.9999 192.302 90.9999 191.75V179.25C91 179.213 90.989 179.176 90.9682 179.145C90.9474 179.114 90.9178 179.089 90.8832 179.075V179.075Z",
    fill: "currentColor"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "I-mainly-write-React",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 36,
    fontWeight: "bold",
    "line-spacing": 46,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40,
    y: 64
  }, "Contact Me"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "I-mainly-write-React",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 14,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 100,
    y: 150
  }, "+33 6 44 13 13 37"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "I-mainly-write-React",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 14,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 100,
    y: 190
  }, "devs@welovedevs.com"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "I-mainly-write-React",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 14,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 100,
    y: 233
  }, "My linkedin profile"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "I-mainly-write-React",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 14,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 100,
    y: 270
  }, "My codingame profile"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "I-mainly-write-React",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 14,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 100,
    y: 310
  }, "Portfolio"))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83 131H72.5C71.837 131 71.2011 131.263 70.7322 131.732C70.2634 132.201 70 132.837 70 133.5V152.5C70 152.828 70.0647 153.153 70.1903 153.457C70.3159 153.76 70.5001 154.036 70.7322 154.268C70.9644 154.5 71.24 154.684 71.5433 154.81C71.8466 154.935 72.1717 155 72.5 155H83C83.3283 155 83.6534 154.935 83.9567 154.81C84.26 154.684 84.5356 154.5 84.7678 154.268C84.9999 154.036 85.1841 153.76 85.3097 153.457C85.4353 153.153 85.5 152.828 85.5 152.5V133.5C85.5 132.837 85.2366 132.201 84.7678 131.732C84.2989 131.263 83.663 131 83 131V131ZM83.5 148.5C83.5 148.898 83.342 149.279 83.0607 149.561C82.7794 149.842 82.3978 150 82 150H73.5C73.1022 150 72.7206 149.842 72.4393 149.561C72.158 149.279 72 148.898 72 148.5V134.5C72 134.102 72.158 133.721 72.4393 133.439C72.7206 133.158 73.1022 133 73.5 133H82C82.3978 133 82.7794 133.158 83.0607 133.439C83.342 133.721 83.5 134.102 83.5 134.5V148.5Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.98 216.5C70.98 217.881 69.87 219 68.5 219C67.13 219 66.02 217.881 66.02 216.5C66.02 215.12 67.13 214 68.5 214C69.87 214 70.98 215.12 70.98 216.5ZM71 221H66V237H71V221ZM78.982 221H74.014V237H78.983V228.601C78.983 223.931 85.012 223.549 85.012 228.601V237H90V226.869C90 218.989 81.078 219.276 78.982 223.155V221Z",
    fill: "#0A66C2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 252H90V276H66V252Z",
    fill: "#FCD207"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 270.85C70.7419 269.723 73.9834 267.587 74.3418 263.51C74.4652 261.999 75.118 260.702 76.8305 259.835C79.2233 258.906 80.3531 259.234 81.324 259.72C82.3917 260.661 82.7005 262.023 81.9001 264C81.5324 265.155 78.5473 266.579 77.1762 266.978C72.6534 269.005 70.3149 271.936 70.7124 276H66V270.85Z",
    fill: "#1F2528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2012 258.913C86.4516 258.913 87.4652 257.923 87.4652 256.701C87.4652 255.479 86.4516 254.489 85.2012 254.489C83.9508 254.489 82.9371 255.479 82.9371 256.701C82.9371 257.923 83.9508 258.913 85.2012 258.913Z",
    fill: "#1F2528"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(66 173)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 252,
    width: 24,
    height: 24,
    rx: 5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.faca951872ecfd1ae9099834c872f61a.svg";
export { ForwardRef as ReactComponent };